<template>
    <form method="post" action="" v-on:submit="submitForm">
        <div class="form-group">
            <label>Code (5 digits): *</label><br />
            <input type="text" name="_id" v-model="finalData._id" :disabled="submitText === 'Update'" required />
        </div>
        <div class="form-group">
            <label>Name: *</label><br />
            <input type="text" name="name" v-model="finalData.name" required />
        </div>
        <div class="form-group">
            <label>Library Limit: *</label><br />
            <input type="text" name="libraryLimit" v-model="finalData.libraryLimit" required />
        </div>

        <h3>Login Access</h3>
        <div class="form-group">
            <label>Email:</label><br />
            <input type="text" name="email" v-model="finalData.email" />
        </div>
        <div class="form-group">
            <label>Password{{ submitText === 'Update' ? ' (leave blank to keep current)' : '' }}:</label><br />
            <input type="text" name="password" v-model="finalData.password" />
        </div>
        <div class="form-group">
            <label>Account Status:</label><br />
            <select v-model="finalData.isEnabled">
                <option :value="true">Enabled</option>
                <option :value="false">Disabled</option>
            </select>
        </div>

        <h3>Access Scope</h3>
        <div class="form-group">
            <label>Scope:</label><br />
            <select v-model="finalData.accessScope">
                <option value="ASSIGNED">Assigned users only</option>
                <option value="COUNTRY">Country-based</option>
                <option value="BOTH">Both (assigned + country)</option>
            </select>
        </div>
        <div class="form-group full-width" v-if="finalData.accessScope === 'COUNTRY' || finalData.accessScope === 'BOTH'">
            <label>Managed Countries (hold Ctrl / Cmd to select multiple):</label><br />
            <select multiple v-model="selectedCountryCodes" class="countries-select">
                <option v-for="c in countries" :key="c.code" :value="c.code">{{ c.name }}</option>
            </select>
        </div>

        <div class="form-group" style="margin-top: 20px;">
            <button type="submit">{{ submitText || 'Submit' }}</button>
        </div>
    </form>
</template>

<script>
import countries from '@/data/countries.js'

export default {
    name: 'AgentForm',
    props: ['formData', 'submitText'],
    emits: ['formSubmitted'],
    data: function() {
        const data = this.formData ? JSON.parse(JSON.stringify(this.formData)) : {}
        if (!data.accessScope) {
            data.accessScope = 'ASSIGNED'
        }
        if (data.isEnabled === undefined) {
            data.isEnabled = true
        }
        return {
            finalData: data,
            selectedCountryCodes: (this.formData?.managedCountries ?? []).map(c => c.code),
            countries
        }
    },
    methods: {
        submitForm(e) {
            e.preventDefault()
            if (this.finalData.accessScope === 'COUNTRY' || this.finalData.accessScope === 'BOTH') {
                this.finalData.managedCountries = this.selectedCountryCodes.map(code => {
                    return this.countries.find(c => c.code === code)
                })
            } else {
                this.finalData.managedCountries = []
            }
            if (!this.finalData.password) {
                delete this.finalData.password
            }
            this.$emit('formSubmitted', this.finalData)
        }
    }
}
</script>

<style lang="scss" scoped>
h3 {
    margin: 20px 0 10px;
}
.form-group {
    display: inline-block;
    width: 100%;
    max-width: 400px;
    margin-bottom: 10px;
    vertical-align: top;

    &.full-width {
        display: block;
        max-width: 600px;
    }
}
.countries-select {
    width: 100%;
    height: 200px;
}
</style>
